import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { ShopifyService } from '../services/shopify.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { widgetsTypes, WidgetService } from '../services/widget.service';
import { combineLatest, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

const widgetTypeToParamKey = {
  [widgetsTypes.mainWidget]: 'mainWidgetInstanceId',
  [widgetsTypes.starRatingsWidget]: 'starRatingWidgetInstanceId',
  [widgetsTypes.questionsAndAnswers]: 'questionsAndAnswersWidgetInstanceId',
  [widgetsTypes.promotedProducts]: 'promotedProductsWidgetInstanceId',
  [widgetsTypes.reviewsCarousel]: 'reviewsCarouselWidgetInstanceId',
  [widgetsTypes.vugcMediaGallery]: 'vugcMediaGalleryWidgetInstanceId',
  [widgetsTypes.reviewsTab]: 'reviewsTabWidgetInstanceId'
};

@Injectable()
export class ShopifyResolver {

  constructor(private shopifyService: ShopifyService,
              private widgetService: WidgetService,
              private route: ActivatedRoute) {}

  init() {
    return this.shopifyService.isShopify2().pipe(
      mergeMap((data: any) => {
        if (data.response) {
          return this.buildIntegrateAppKeyParams(this.route.snapshot.queryParams.widgetType).pipe(
            mergeMap(params => this.shopifyService.integrateAppKey(params)),
            mergeMap(() => this.shopifyService.shopDeeplink()),
            mergeMap((res: any) => of({shopDeeplink: res.response}))
          );
        }
        return of({shopDeeplink: undefined, err: 'not Shopify 2'});
      }),
      catchError((err) => of({shopDeeplink: undefined, err}))
    );
  }

  private buildIntegrateAppKeyParams(widgetType): Observable<any> {
    if (widgetType && widgetTypeToParamKey[widgetType]) {
      return this.widgetService.getWidgetV3InstanceId(widgetType).pipe(
        map(instanceId => {
          return instanceId ? {[widgetTypeToParamKey[widgetType]]: instanceId} : null;
        }));
    }
    return this.buildIntegrateAppKeyDefaultParams();
  }

  private buildIntegrateAppKeyDefaultParams(): Observable<any> {
    return combineLatest([
      this.widgetService.getWidgetV3InstanceId(widgetsTypes.mainWidget),
      this.widgetService.getWidgetV3InstanceId(widgetsTypes.starRatingsWidget)
    ]).pipe(
      map(([mainWidgetInstanceId, starRatingWidgetInstanceId]) => {
        if (mainWidgetInstanceId || starRatingWidgetInstanceId) {
          return {
            [widgetTypeToParamKey[widgetsTypes.mainWidget]]: mainWidgetInstanceId,
            [widgetTypeToParamKey[widgetsTypes.starRatingsWidget]]: starRatingWidgetInstanceId
          };
        }
        return null;
      })
    );
  }
}
